import React from 'react'
import { AllCardsType } from '../../../data/all-cards'

const POSICIONES = [
    'Energía actual',
    'Lo que no ve',
    'Energía con esa persona',
    'Naturaleza',
    'Involucramiento',
    'Qué aclarar',
    'Consejo',
    'Posible desarrollo',
    'Clarificación 1',
    'Clarificación 2',
]

export const ShowCards = ({ selectedCards, mazo }: { selectedCards: AllCardsType[]; mazo: string }) => {
    return (
        <div className="flex flex-col items-center w-full h-full mini:px-2 md:px-5">
            <div className="flex flex-wrap justify-center gap-3 mini:pt-10 xl:pt-0">
                {selectedCards.map((card: AllCardsType, index: number) => (
                    <div className="flex flex-col gap-1" key={`${card.id}-${index}`}>
                        <div className="mini:w-[17vw] xl:w-[8.38vw] bg-violetDark text-white mini:text-[10px] xl:text-xs text-center rounded-md px-1 py-0.5 leading-tight">
                            {POSICIONES[index] ?? `Carta ${index + 1}`}
                        </div>
                        <img
                            src={require('../../../assets/' + mazo + card.url + '/' + card.image)}
                            className={`mini:w-[17vw] xl:w-[8.38vw] mini:h-auto xl:h-auto rounded-md ${
                                card.position === 'invertida' ? 'rotate-180' : ''
                            }`}
                            alt=""
                        />
                        <div className="mini:w-[17vw] xl:w-[8.38vw] bg-violetLight mini:text-sm xl:text-base text-center rounded-md">
                            {card.name}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
